<script setup lang="ts">
import FeedbackPicker from '@/Components/FeedbackPicker.vue';
import { ref } from 'vue';
import { useParticipantStore } from '@/Stores/ParticipantStore';
import { useRouter } from 'vue-router';

const router = useRouter()
const pStore = useParticipantStore()

const rating = ref<string | null>(null)
const submitting = ref(false)

async function submit() {
    if (!rating.value || submitting.value) {
        return
    }

    submitting.value = true

    const res = await pStore.sendFeedback(rating.value)
    if (!res.ok) {
        submitting.value = false
        return
    }

    router.push({ name: 'PartQEnd', replace: true })
}
</script>

<template>
    <div class="absolute col items-center w-full mt-20">
        <p class="text-lg">
            Valuta il consulente che ti ha assistito
        </p>
    </div>
    <div class="col items-center justify-center h-full text-lg gap-3">
        <FeedbackPicker v-model="rating" />
    </div>
    <button :disabled="!rating || submitting" @click="submit" data-testid="feedback-submit"
        class="btn-primary absolute bottom-20 left-[50%] translate-x-[-50%] text-md! p-4!">
        Conferma
    </button>
</template>
